<template>
  <div
    ref="rankingPortePopulacionalPage"
    class="ranking-porte-populacional-page"
  >
    <div class="ranking-container">
      <RankingHeader @exportar="exportarRanking" />

      <RankingFilters
        :quadrimestre="quadrimestre"
        :portePopulacional="portePopulacional"
        :regiao="regiao"
        :quadrimestres="quadrimestres"
        :optionsPortePopulacional="optionsPortePopulacional"
        @change-quadrimestre="onChangeQuadrimestre"
        @change-porte-populacional="onChangePortePopulacional"
        @change-regiao="onChangeRegiao"
        @limpar="limparFiltros"
      />

      <div v-if="isLoading" class="loading-card">
        <b-spinner large style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <div v-else>
        <!-- <RankingInfoBox /> -->

        <!-- <RankingColumnInfo :info="info" /> -->

        <RankingTable
          :items="rankingFiltrado"
          :search="search"
          @change-search="search = $event"
          @detalhar="abrirModal"
          @hover-column="updateInfo"
          @abrir-simulador="abrirSimulador"
          @abrir-desempenho="abrirDesempenho"
        />

        <button
          v-show="showBackToTop"
          class="back-to-top-btn"
          @click="scrollToTop"
          title="Voltar ao topo"
        >
          <i class="icofont-long-arrow-up"></i>
        </button>
      </div>

      <RankingDetailsModal
        :visible="modalVisible"
        :municipio="municipioSelecionado"
        :estado="estado"
        :escopo-ranking="{
          ied: escopoRanking,
        }"
        @close="fecharModal"
      />

      <ModalSimulador
        v-if="showSimuladorModal"
        :municipio="municipioSimulador"
        @close="fecharSimulador"
      />

      <ModalDesempenho
        :visible="showDesempenhoModal"
        :municipio="municipioDesempenho"
        :regiao="regiao"
        page="ranking-porte-populacional"
        @close="fecharDesempenho"
      />
    </div>
  </div>
</template>

<script>
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

import RankingHeader from '../RankingGeral/components/RankingHeader.vue'
import RankingInfoBox from '../RankingGeral/components/RankingInfoBox.vue'
import RankingSearch from '../RankingGeral/components/RankingSearch.vue'
import RankingTable from '../RankingGeral/components/RankingTable.vue'
import RankingDetailsModal from '../RankingGeral/components/RankingDetailsModal.vue'
import RankingFilters from './components/RankingFilters.vue'
import RankingColumnInfo from '../RankingGeral/components/RankingColumnInfo.vue'
import ModalSimulador from '../RankingGeral/components/ModalSimulador.vue'
import ModalDesempenho from '../RankingGeral/components/ModalDesempenho.vue'

export default {
  name: 'RankingPortePopulacional',
  components: {
    RankingHeader,
    RankingInfoBox,
    RankingSearch,
    RankingTable,
    RankingDetailsModal,
    RankingFilters,
    RankingColumnInfo,
    ModalSimulador,
    ModalDesempenho,
  },
  data() {
    return {
      ranking: [],
      search: '',
      quadrimestre: '',
      estado: '',
      info: {
        type: 'ranking',
        title:
          'Passe o mouse sobre uma coluna para visualizar a descrição do indicador ou critério.',
      },
      isLoading: false,
      modalVisible: false,
      municipioSelecionado: null,
      quadrimestres: [],
      showBackToTop: false,
      showSimuladorModal: false,
      municipioSimulador: null,
      portePopulacional: '',
      optionsPortePopulacional: [
        { value: 1, label: '1 a 1.999' },
        { value: 2, label: '2.000 a 3.999' },
        { value: 4, label: '4.000 a 5.999' },
        { value: 6, label: '6.000 a 7.999' },
        { value: 8, label: '8.000 a 9.999' },
        { value: 10, label: '10.000 a 11.999' },
        { value: 12, label: '12.000 a 13.999' },
        { value: 14, label: '14.000 a 15.999' },
        { value: 16, label: '16.000 a 17.999' },
        { value: 18, label: '18.000 a 19.999' },
        { value: 20, label: '20.000 a 29.999' },
        { value: 30, label: '30.000 a 39.999' },
        { value: 40, label: '40.000 a 49.999' },
        { value: 50, label: '50.000 a 59.999' },
        { value: 60, label: '60.000 a 69.999' },
        { value: 70, label: '70.000 a 79.999' },
        { value: 80, label: '80.000 a 89.999' },
        { value: 90, label: '90.000 a 99.999' },
        { value: 100, label: '100.000 a 199.999' },
        { value: 200, label: '200.000 a 299.999' },
        { value: 300, label: '300.000 a 399.999' },
        { value: 400, label: '400.000 a 499.999' },
        { value: 500, label: '500.000 a 599.999' },
        { value: 600, label: '600.000 a 999.999' },
        { value: 1000, label: '1.000.000 ou mais' },
      ],
      showDesempenhoModal: false,
      municipioDesempenho: null,
      regiao: '',
    }
  },
  computed: {
    /**
     * Retorna o ranking filtrado pelo nome do município.
     *
     * @returns {Array}
     */
    rankingFiltrado() {
      const termo = this.normalizarTexto(this.search)

      return this.ranking
        .filter((item) => {
          const passaNome =
            !termo || this.normalizarTexto(item.municipio).includes(termo)

          const passaQuadrimestre =
            !this.quadrimestre || item.quadrimestre === this.quadrimestre

          const passaPortePopulacional =
            !this.portePopulacional ||
            Number(item.int_faixa_port_pop) === Number(this.portePopulacional)

          const passaRegiao = !this.regiao || item.regiao_ibge === this.regiao

          return (
            passaNome &&
            passaQuadrimestre &&
            passaPortePopulacional &&
            passaRegiao
          )
        })
        .map((item, index) => ({
          ...item,
          posicaoReal: this.regiao
            ? item.posicao_faixa_pop_regiao_ibge || index + 1
            : item.posicao_faixa_pop || index + 1,
        }))
    },

    escopoRanking() {
      if (!this.portePopulacional) {
        return ''
      }

      const siglas = {
        Norte: 'N',
        Nordeste: 'NE',
        'Centro-Oeste': 'CO',
        Sudeste: 'SE',
        Sul: 'S',
      }

      return this.regiao
        ? `${siglas[this.regiao]} ${this.portePopulacional}K`
        : `BR ${this.portePopulacional}K`
    },
  },
  watch: {
    quadrimestre() {
      this.carregarRanking()
    },

    portePopulacional() {
      this.carregarRanking()
    },
  },
  mounted() {
    this.carregarQuadrimestres()
    this.$refs.rankingPortePopulacionalPage.addEventListener(
      'scroll',
      this.handleScroll
    )
  },

  beforeDestroy() {
    this.$refs.rankingPortePopulacionalPage.removeEventListener(
      'scroll',
      this.handleScroll
    )
  },
  methods: {
    /**
     * Controla a exibição do botão voltar ao topo.
     *
     * @returns {void}
     */
    handleScroll() {
      this.showBackToTop =
        this.$refs.rankingPortePopulacionalPage.scrollTop > 300
    },

    /**
     * Rola suavemente a página para o topo.
     *
     * @returns {void}
     */
    scrollToTop() {
      this.$refs.rankingPortePopulacionalPage.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },

    /**
     * Busca os quadrimestres disponíveis.
     *
     * @returns {Promise<void>}
     */
    async carregarQuadrimestres() {
      const { data } = await this.$apiPublic.get(
        '/cofinanciamento-federal/ranking-geral/quadrimestres'
      )

      const quadrimestres = data.data || []

      this.quadrimestres = quadrimestres.map((item) => ({
        value: item.quadrimestre,
        label: item.quadrimestre,
      }))

      this.quadrimestre = this.quadrimestres[0].value
      this.portePopulacional = 1
    },

    /**
     * Busca o ranking APS por filtros opcionais.
     *
     * @returns {Promise<Array>}
     */
    async buscarRankingAps() {
      const { data } = await this.$apiPublic.get(
        '/cofinanciamento-federal/ranking-geral',
        {
          params: {
            quadrimestre: this.quadrimestre || undefined,
            porte_populacional: this.portePopulacional || undefined,
          },
        }
      )

      return data.data || []
    },

    /**
     * Busca os dados da API e monta o ranking.
     *
     * @returns {Promise<void>}
     */
    async carregarRanking() {
      if (!this.quadrimestre) {
        this.ranking = []
        this.search = ''
        return
      }

      this.isLoading = true

      try {
        const response = await this.buscarRankingAps()

        this.ranking = response
          .map(this.normalizarItemRanking)
          .map((item, index) => {
            return {
              ...item,
              posicaoReal: item.posicao_faixa_pop || index + 1,
            }
          })
      } finally {
        this.isLoading = false
      }
    },

    /**
     * Monta a lista de quadrimestres disponíveis conforme retorno da API.
     *
     * @param {Array} dados Dados retornados pela API.
     * @returns {void}
     */
    montarQuadrimestres(dados) {
      const quadrimestres = [
        ...new Set(dados.map((item) => item.quadrimestre).filter(Boolean)),
      ]

      this.quadrimestres = quadrimestres.map((item) => ({
        value: item,
        label: item,
      }))
    },

    /**
     * Abre o modal de detalhamento.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirModal(municipio) {
      this.municipioSelecionado = municipio
      this.modalVisible = true
    },

    /**
     * Fecha o modal de detalhamento.
     *
     * @returns {void}
     */
    fecharModal() {
      this.modalVisible = false
      this.municipioSelecionado = null
    },

    /**
     * Normaliza texto para busca sem acentos.
     *
     * @param {string} texto Texto informado.
     * @returns {string}
     */
    normalizarTexto(texto) {
      return String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },

    /**
     * Normaliza o item retornado pela API para uso na tabela.
     *
     * @param {Object} item Município retornado pela API.
     * @returns {Object}
     */
    normalizarItemRanking(item) {
      const classificacoes = [
        item.regular,
        item.suficiente,
        item.bom,
        item.otimo,
      ]

      const totalCvat = classificacoes.reduce((total, classificacao) => {
        return (
          total +
          Number(classificacao?.eap_cvat || 0) +
          Number(classificacao?.esf_cvat || 0)
        )
      }, 0)

      const totalGeral = Number(item.equipes_aval_quad || 0) - totalCvat

      return {
        ...item,
        key: `${item.ibge}_${item.quadrimestre}`,
        municipio: item.municipio,
        totalGeral: totalGeral,
        notaGeral: Number(item.desempenho || 0),
        indicadores: Array.isArray(item.indicadores) ? item.indicadores : [],
        desempenhoIndicadores: Number(item.desempenho_indicadores || 0),
        populacao: Number(item.pop_ibge_ano_anterior || 0),
        ied: item.ied || '-',
      }
    },

    /**
     * Exporta o ranking atual para CSV.
     *
     * @returns {void}
     */
    exportarRanking() {
      // console.log('Exportar ranking:', this.ranking)
    },

    /**
     * Atualiza o texto informativo conforme a coluna destacada.
     *
     * @param {string} type Tipo da coluna.
     * @returns {void}
     */
    updateInfo(type) {
      const infos = {
        default:
          'Passe o mouse sobre uma coluna para visualizar a descrição do indicador ou critério.',
        tem: 'Indica se o município possui acesso ou vínculo com o eSUS Feedback.',
        municipio: 'Municípios ordenados conforme os critérios do ranking.',
        regular: 'Percentual de equipes classificadas como Regular.',
        suficiente: 'Percentual de equipes classificadas como Suficiente.',
        bom: 'Percentual de equipes classificadas como Bom.',
        otimo: 'Percentual de equipes classificadas como Ótimo.',
        desempenho: 'Nota geral calculada com pesos por classificação.',
      }

      this.info = {
        type,
        title: infos[type] || infos.default,
      }
    },

    /**
     * Abre o modal do simulador.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirSimulador(municipio) {
      this.municipioSimulador = municipio
      this.showSimuladorModal = true
    },

    /**
     * Fecha o modal do simulador.
     *
     * @returns {void}
     */
    fecharSimulador() {
      this.showSimuladorModal = false
      this.municipioSimulador = null
    },

    /**
     * Gera o PDF do ranking filtrado.
     *
     * @returns {void}
     */
    gerarPdf() {
      if (!this.rankingFiltrado.length) {
        alert('Nenhum dado disponível para gerar o PDF.')
        return
      }

      const doc = new jsPDF('landscape', 'mm', 'a4')

      const filtroEstado = this.estado || 'Todos os estados'
      const filtroQuadrimestre = this.quadrimestre || 'Todos os quadrimestres'
      const titulo = 'Ranking Resultado Cofinanciamento Federal da APS'

      const headers = [
        'Posição',
        'eSUS Feedback',
        'Município',
        'Regular',
        'Suficiente',
        'Bom',
        'Ótimo',
        'Desempenho',
        // 'Total Equipes',
      ]

      const rows = this.rankingFiltrado.map((item) => [
        `${item.posicaoReal}º`,
        item.tem_esus_feedback ? 'Sim' : 'Não',
        `${item.municipio} - ${item.uf}`,
        item.regular ? this.formatPdfPercent(item.regular.prcntl_eq_aval) : '',
        item.suficiente
          ? this.formatPdfPercent(item.suficiente.prcntl_eq_aval)
          : '',
        item.bom ? this.formatPdfPercent(item.bom.prcntl_eq_aval) : '',
        item.otimo ? this.formatPdfPercent(item.otimo.prcntl_eq_aval) : '',
        Number(item.notaGeral || 0).toFixed(1),
        // item.totalGeral,
      ])

      const dataAtual = new Date().toLocaleDateString('pt-BR')

      doc.setFontSize(14)
      doc.text(titulo, 148, 14, { align: 'center' })

      doc.setFontSize(9)
      doc.text(`Estado: ${filtroEstado}`, 14, 24)
      doc.text(`Quadrimestre: ${filtroQuadrimestre}`, 14, 30)
      doc.text(`Gerado em: ${dataAtual}`, 14, 36)

      doc.autoTable({
        head: [headers],
        body: rows,
        startY: 44,
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 2,
          halign: 'center',
          valign: 'middle',
          lineColor: [217, 226, 236],
          lineWidth: 0.1,
        },
        headStyles: {
          fillColor: [243, 244, 246],
          textColor: [55, 65, 81],
          fontStyle: 'bold',
          lineColor: [209, 213, 219],
          lineWidth: 0.1,
        },
        columnStyles: {
          2: {
            halign: 'left',
            cellWidth: 60,
          },
        },
      })

      doc.save(`ranking-aps-${filtroQuadrimestre}.pdf`)
    },

    /**
     * Formata percentual para exibição no PDF.
     *
     * @param {number|string|null} value Valor percentual.
     * @returns {string}
     */
    formatPdfPercent(value) {
      if (value === null || value === undefined || value === '') {
        return ''
      }

      return `${Number(value).toFixed(1)}%`
    },

    /**
     * Limpa os filtros da tela.
     *
     * @returns {void}
     */
    limparFiltros() {
      this.quadrimestre = this.quadrimestres[0]?.value || ''
      this.portePopulacional = 1
      this.search = ''
      this.regiao = ''
    },

    /**
     * Atualiza o quadrimestre selecionado.
     *
     * Limpa todos os filtros dependentes, reiniciando a navegação
     * por quadrimestre e portePopulacional.
     *
     * @param {String} value Quadrimestre selecionado.
     */
    onChangeQuadrimestre(value) {
      this.quadrimestre = value
      this.portePopulacional = 1
      this.regiao = ''
    },

    /**
     * Atualiza o porte populacional selecionado.
     *
     * @param {String} value porte populacional selecionado.
     */
    onChangePortePopulacional(value) {
      this.portePopulacional = value
    },

    /**
     * Atualiza a região selecionada.
     *
     * @param {String} value Região IBGE selecionada.
     */
    onChangeRegiao(value) {
      this.regiao = value
    },

    /**
     * Abre o modal de desempenho.
     *
     * @param {Object} municipio Município selecionado.
     * @returns {void}
     */
    abrirDesempenho(municipio) {
      this.municipioDesempenho = municipio
      this.showDesempenhoModal = true
    },

    /**
     * Fecha o modal de desempenho.
     *
     * @returns {void}
     */
    fecharDesempenho() {
      this.showDesempenhoModal = false
      this.municipioDesempenho = null
    },
  },
}
</script>

<style scoped>
.ranking-porte-populacional-page {
  background: #f9fafb;
  height: 100vh;
  overflow-y: auto;
  padding: 24px;
  color: #1f2937;
}

.ranking-container {
  margin: 0 auto;
}

.loading-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 24px;
  text-align: center;
  color: #6b7280;
}

.back-to-top-btn {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 48px;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 16px 35px rgba(37, 99, 235, 0.35);
  cursor: pointer;
  z-index: 50;
  transition: 0.2s ease;
  font-size: 30px;
}

.back-to-top-btn:hover {
  background: #1d4ed8;
  transform: translateY(-2px);
}
</style>
